module.exports = __webpack_public_path__ + "img/28.96ac1d56.jpg";